"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Month = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _Colors = require("./Colors");
var _CurrencyFormat = require("../CurrencyFormat/CurrencyFormat");
var Month = exports.Month = function Month(_ref) {
  var month = _ref.month,
    onClick = _ref.onClick;
  if (!month) return null;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var text = month.text,
    link = month.link,
    price = month.price,
    segment = month.segment;
  var _STYLES_MAP$segment = _Colors.STYLES_MAP[segment],
    background = _STYLES_MAP$segment.background,
    segmentColor = _STYLES_MAP$segment.segmentColor,
    priceColor = _STYLES_MAP$segment.priceColor;
  return /*#__PURE__*/_react["default"].createElement(StyledAnchor, {
    onClick: onClick,
    style: {
      background: background
    },
    href: link,
    key: text
  }, /*#__PURE__*/_react["default"].createElement(StyledMonthContainer, {
    hasInfo: true
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      color: segmentColor.color,
      opacity: segmentColor.opacity
    }
  }, text), /*#__PURE__*/_react["default"].createElement("p", null, price !== null ? /*#__PURE__*/_react["default"].createElement(_CurrencyFormat.CurrencyFormat, {
    style: {
      color: priceColor
    },
    value: price
  }) : /*#__PURE__*/_react["default"].createElement(StyledNoInfo, null, t('monthSegments.noData')))));
};
var StyledAnchor = _styledComponents["default"].a.withConfig({
  displayName: "Month__StyledAnchor",
  componentId: "sc-12y2nwi-0"
})(["display:flex;align-items:center;justify-content:center;text-decoration:none;flex-grow:1;min-width:80px;height:42px;white-space:nowrap;:first-child{border-bottom-left-radius:6px;border-top-left-radius:6px;}:last-child{border-bottom-right-radius:6px;border-top-right-radius:6px;}"]);
var StyledMonthContainer = _styledComponents["default"].div.withConfig({
  displayName: "Month__StyledMonthContainer",
  componentId: "sc-12y2nwi-1"
})(["text-align:center;", ""], function (_ref2) {
  var hasInfo = _ref2.hasInfo,
    theme = _ref2.theme;
  return !hasInfo && "\n    min-width: 70px;\n    display: flex;\n    align-items: center;\n    padding: 0 4px;\n    color: ".concat(theme.colors.frenchGray, ";\n    background-color: #fff;\n  ");
});
var StyledNoInfo = _styledComponents["default"].span.withConfig({
  displayName: "Month__StyledNoInfo",
  componentId: "sc-12y2nwi-2"
})(["color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.frenchGray;
});